import React from "react";
import MainPage from '../../pages/MainPage';
import UsersPage from "../../pages/UsersPage";
import DestinosPages from "../../pages/DestinosPages";
import ProveedoresPage from "../../pages/ProveedoresPage";
import UsuariosProveedoresPages from "../../pages/UsuariosProveedoresPage";
import DashboardProveedores from "../../pages/proveedores/DashboardProveedores";
import AdminGuias from "../../pages/proveedores/AdminGuias";
import EnviosUsuariosPage from "../../pages/usuarios/EnviosUsuariosPage";
import EmbarquesPage from "../../pages/usuarios/EmbarquesPage";
import EnviosProveedores from "../../pages/proveedores/EnvíosProveedoresPage";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarcode, faTruckLoading } from '@fortawesome/free-solid-svg-icons';
import SendIcon from '@mui/icons-material/Send';
import HomeIcon from '@mui/icons-material/Home';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import GroupIcon from '@mui/icons-material/Group';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';

var dashRoutes = [
    // PROVEEDORES
    {
        path: "/Dashboard",
        name: "Dashboard",
        icon: <HomeIcon/>,
        component: DashboardProveedores,
        layout: "/Proveedores",
        clave: 'MDAS002'
    },
    {
        path: "/Envios",
        name: "Envíos",
        icon: <SendIcon/>,
        component: EnviosProveedores,
        layout: "/Proveedores",
        clave: 'MENV002'
    },
    // USUARIOS
    {
        path: "/Dashboard",
        name: "Dashboard",
        icon: <HomeIcon/>,
        component: MainPage,
        layout: "/Usuarios",
        clave: 'MDAS001'
    },
    {
        path: "/Usuarios",
        name: "Usuarios",
        icon: <GroupIcon/>,
        component: UsersPage,
        layout: "/Usuarios",
        clave: 'MUSU001'
    },
    {
        path: "/Destinos",
        name: "Destinos",
        icon: <LocationOnIcon/>,
        component: DestinosPages,
        layout: "/Usuarios",
        clave: 'MDES001'
    },
    {
        path: "/Proveedores",
        name: "Proveedores",
        icon: <LocalShippingIcon/>,
        component: ProveedoresPage,
        layout: "/Usuarios",
        clave: 'MPRO001'
    },
    {
        path: "/Envios",
        name: "Envios",
        icon: <SendIcon/>,
        component: EnviosUsuariosPage,
        layout: "/Usuarios",
        clave: 'MENV001'
    },
    {
        path: "/Embarques",
        name: "Embarques",
        icon: <FontAwesomeIcon icon={faTruckLoading} />,
        component: EmbarquesPage,
        layout: "/Usuarios",
        clave: 'MEMB001'
    },
];

export default dashRoutes;